var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.loading)?_c('v-skeleton-loader',{attrs:{"type":"image"}}):(_vm.blobUrl)?_c('v-img',{attrs:{"src":_vm.blobUrl,"width":_vm.size,"contain":""}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }